module.exports = __webpack_public_path__ + "img/coins.71f24c01.svg";